import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "typeInput", "idInput"]

  disconnect() {
    this.toggleScrollLock(false, true)
  }

  open(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    const type = event.currentTarget.dataset.type
    const id = event.currentTarget.dataset.id

    if (this.hasTypeInputTarget) this.typeInputTarget.value = type
    if (this.hasIdInputTarget) this.idInputTarget.value = id

    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.toggleScrollLock(true)
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    this.toggleScrollLock(false)
  }

  toggleScrollLock(lock, force = false) {
    const body = document.body
    const html = document.documentElement
    let openModals = parseInt(body.dataset.openModals || "0")

    if (lock) {
      openModals++
      body.dataset.openModals = openModals
      
      if (openModals === 1) {
        this.scrollPos = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.scrollPos}px`
        body.style.width = '100%'
        body.classList.add('overflow-hidden')
        html.classList.add('overflow-hidden')
      }
    } else {
      openModals = force ? 0 : Math.max(0, openModals - 1)
      body.dataset.openModals = openModals
      
      if (openModals === 0) {
        const scrollY = body.style.top
        body.style.position = ''
        body.style.top = ''
        body.style.width = ''
        body.classList.remove('overflow-hidden')
        html.classList.remove('overflow-hidden')
        if (!force) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
      }
    }
  }
}
